export default "__VITE_ASSET__BkOc7X9H__"